import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/store";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleAuth(intent = "/minha-conta") {
  sessionStorage.setItem("post_login_intent", intent);
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const nav = useNavigate();
  const location = useLocation();
  const { login, register } = useAuth();
  const [tab, setTab] = useState("customer");
  const [form, setForm] = useState({
    name: "", email: "", phone: "", password: "",
    birthday: "", anniversary: "", dating_start: "", instagram: "",
  });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const nextRoute = new URLSearchParams(location.search).get("next") || "/minha-conta";
  const needsLoginFor = location.state?.reason;
  const isAppointmentIntent = nextRoute === "/agendar" || needsLoginFor === "appointment";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (tab === "register") {
        await register(form);
        toast.success("Bem-vindo(a)!");
        nav(nextRoute);
      } else {
        const user = await login(form.email, form.password, tab);
        toast.success(`Olá, ${user.name}!`);
        nav(user.role === "admin" ? "/admin" : nextRoute);
      }
    } catch (err) { toast.error(err?.response?.data?.detail || "Erro"); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-lg px-6 py-16" data-testid="login-root">
      <div className="text-center">
        <div className="eyebrow">Área do cliente</div>
        <h1 className="mt-2 font-display text-4xl text-[#0D1B2A]">{tab === "register" ? "Criar conta" : "Entrar"}</h1>
        {isAppointmentIntent && (
          <div data-testid="appointment-login-banner" className="mt-4 mx-auto max-w-sm bg-[#F7F2E7] border border-[#D4AF37]/40 rounded-2xl p-4 text-sm text-[#3A4A5F]">
            Para <b>agendar</b> uma sessão, retirada ou orçamento, é preciso ter uma conta. É bem rápido!
          </div>
        )}
        {tab === "register" && !isAppointmentIntent && <p className="mt-2 text-sm text-[#6B7280]">Ao cadastrar, guardamos suas datas especiais e enviamos sugestões personalizadas.</p>}
      </div>

      <div className="mt-8 grid grid-cols-3 gap-2 bg-white rounded-full p-1 border border-[#0D1B2A]/10">
        {[["customer", "Entrar"], ["register", "Cadastrar"], ["admin", "Admin"]].map(([k, l]) => (
          <button key={k} data-testid={`tab-${k}`} onClick={() => setTab(k)}
            className={`py-2 rounded-full text-sm font-medium transition-colors ${tab === k ? "bg-[#0D1B2A] text-white" : "text-[#0D1B2A]"}`}>
            {l}
          </button>
        ))}
      </div>

      {tab !== "admin" && (
        <div className="mt-6">
          <button
            data-testid="google-login-btn"
            type="button"
            onClick={() => startGoogleAuth(nextRoute)}
            className="w-full bg-white hover:bg-[#F7F2E7] border border-[#0D1B2A]/15 rounded-full py-3 flex items-center justify-center gap-3 font-medium text-[#0D1B2A] transition-colors shadow-sm"
          >
            <svg width="20" height="20" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            Continuar com Google
          </button>
          <div className="my-6 flex items-center gap-4">
            <div className="flex-1 h-px bg-[#0D1B2A]/10" />
            <span className="text-[11px] tracking-widest text-[#6B7280] uppercase">ou com e-mail</span>
            <div className="flex-1 h-px bg-[#0D1B2A]/10" />
          </div>
        </div>
      )}

      <form onSubmit={submit} className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 space-y-4">
        {tab === "register" && (
          <>
            <div className="grid sm:grid-cols-2 gap-3">
              <Field l="Nome" v={form.name} onC={(v) => set("name", v)} testId="login-name" required />
              <Field l="WhatsApp" v={form.phone} onC={(v) => set("phone", v)} testId="login-phone" required />
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              <Field l="Aniversário" type="date" v={form.birthday} onC={(v) => set("birthday", v)} testId="login-birthday" />
              <Field l="Casamento" type="date" v={form.anniversary} onC={(v) => set("anniversary", v)} testId="login-anniv" />
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              <Field l="Início do namoro" type="date" v={form.dating_start} onC={(v) => set("dating_start", v)} testId="login-dating" />
              <Field l="Instagram (@)" v={form.instagram} onC={(v) => set("instagram", v)} testId="login-ig" placeholder="seu.arroba" />
            </div>
          </>
        )}
        <Field l="E-mail" type="email" v={form.email} onC={(v) => set("email", v)} testId="login-email" required />
        <Field l="Senha" type="password" v={form.password} onC={(v) => set("password", v)} testId="login-password" required />
        <button data-testid="login-submit" disabled={loading} className="btn-gold w-full py-3">
          {loading ? "..." : tab === "register" ? "Criar conta e ganhar 10% off" : "Entrar"}
        </button>
        {tab === "customer" && <p className="text-xs text-center text-[#6B7280]">Novo por aqui? <button type="button" onClick={() => setTab("register")} className="text-[#D4AF37]">Cadastre-se</button></p>}
      </form>
    </div>
  );
}

const Field = ({ l, v, onC, type = "text", testId, required, placeholder }) => (
  <div>
    <label className="text-sm text-[#3A4A5F]">{l}</label>
    <input data-testid={testId} required={required} type={type} value={v} onChange={(e) => onC(e.target.value)} className="input-luxe mt-1" placeholder={placeholder} />
  </div>
);
